import { ILightNestedUser, LightNestedUserUtils } from "./lightNestedUser";

export interface ILightGroup {
  id: string;
  name: string;
  parentGroup: string | null;
  groupOwner: string[];
  nestedUsers: ILightNestedUser[];
  // nestedPolicies: ILightPolicy[];
  isValid: boolean;
  isDeleted: boolean;
}

export const LightGroupUtils = {
  create({
    id = "",
    name = "",
    parentGroup = null,
    groupOwner = [],
    nestedUsers = [],
    isValid,
    isDeleted,
  }: {
    id?: string;
    name?: string;
    parentGroup?: string | null;
    groupOwner?: string[];
    nestedUsers?: ILightNestedUser[];
    isValid: boolean;
    isDeleted: boolean;
  }): ILightGroup {
    return {
      id,
      name,
      parentGroup,
      groupOwner,
      nestedUsers,
      isValid: isValid,
      isDeleted: isDeleted,
    };
  },

  empty(): ILightGroup {
    return LightGroupUtils.create({
      id: "",
      name: "",
      parentGroup: null,
      groupOwner: [],
      nestedUsers: [],
      isValid: false,
      isDeleted: false,
    });
  },

  fromMap(map: Record<string, any>): ILightGroup {
    try {
      const object = map["object"] ?? {};
      return LightGroupUtils.create({
        id: String(object["id"] ?? ""),
        name: String(object["name"] ?? ""),
        parentGroup: String(object["parentGroup"] ?? ""),
        groupOwner: object["groupOwner"] ? (object["groupOwner"] as string[]) : [],
        nestedUsers:
          map["nestedUsers"] && map["nestedUsers"] !== ""
            ? (map["nestedUsers"] as any[])
                .map((e) => LightNestedUserUtils.fromMap(e))
                .filter((u) => u.isValid)
            : [],
        isValid: !!map["isValid"],
        isDeleted: !!map["isDeleted"],
      });
    } catch (e) {
      console.error("Error creating ILightGroup from map:", e);
      return LightGroupUtils.empty();
    }
  },

  fromJson(source: string): ILightGroup {
    try {
      return LightGroupUtils.fromMap(JSON.parse(source));
    } catch (e) {
      console.error("Error parsing ILeanGroup from JSON:", e);
      return LightGroupUtils.empty();
    }
  },

  toMap(lightGroup: ILightGroup): Record<string, any> {
    return {
      id: lightGroup.id,
      name: lightGroup.name,
      parentGroup: lightGroup.parentGroup,
      nestedUsers: lightGroup.nestedUsers.map((user) => LightNestedUserUtils.toMap(user)),
      isValid: lightGroup.isValid,
      isDeleted: lightGroup.isDeleted,
    };
  },

  toJson(lightGroup: ILightGroup): string {
    return JSON.stringify(LightGroupUtils.toMap(lightGroup));
  },

  copyWith(
    lightGroup: ILightGroup,
    {
      id,
      name,
      parentGroup,
      groupOwner,
      nestedUsers,
      isValid,
      isDeleted,
    }: {
      id?: string;
      name?: string;
      parentGroup?: string | null;
      groupOwner?: string[];
      nestedUsers?: ILightNestedUser[];
      isValid?: boolean;
      isDeleted?: boolean;
    }
  ): ILightGroup {
    return LightGroupUtils.create({
      id: id ?? lightGroup.id,
      name: name ?? lightGroup.name,
      parentGroup: parentGroup ?? lightGroup.parentGroup,
      groupOwner: groupOwner ?? lightGroup.groupOwner,
      nestedUsers: nestedUsers ?? lightGroup.nestedUsers,
      isValid: isValid ?? lightGroup.isValid,
      isDeleted: isDeleted ?? lightGroup.isDeleted,
    });
  },
};
